module.exports = __webpack_public_path__ + "assets/img/video-btn-2f88f9d0.png";